
// Copyright © 2020 Verimatrix, Inc. All rights reserved.

export const VCASCLOUD_PATH = 'vcas-cloud'
export const DEVICES_PATH = 'devices'
export const DOMAINS_PATH = 'domains'
export const ENTITLEMENTS_PATH = 'entitlements'
